import Slogun from '../../components/Slogun';
import Footer from '../../components/Footer';
import Recommend from '../../components/Recommend';

function Product(props) {
  const productList = [
    {
      title: '엄선된 원재료',
      desc: '뉴질랜드산 파이너스 라디아타(PinusRadiata)<br /> 소나무 껍질에서 유전학적으로<br class="lg:hidden" /> 동일한 25~30년생 소나무만 선별',
    },
    {
      title: '국제 특허 기술인 순수 물추출',
      desc: '국제 특허 기술인 순수 물추출(수용성)<br class="lg:hidden" /> 추출한 100% 천연 액기스 공법',
    },
    {
      title: '특별하게 배합한 부원료',
      desc: '천연 엔조제놀 뿐만아니아 1일 EPA,<br class="lg:hidden" /> DHA 900mg 섭취 가능',
    },
    {
      title: '천연 항산화제',
      desc: '뇌관문을 통과하여 뇌에까지<br class="lg:hidden" /> 직접 작용할 수 있는 특별한 항산화제',
    },
    {
      title: '안전하게 흡수',
      desc: '저분자 항산화 물질로 소화기관에서<br class="lg:hidden" /> 분해되지않고 플라보노이드는<br /> 소화액의 영향을 받지 않고 흡수됨. ',
    },
  ];

  return (
    <>
      <div className='w-full h-full'>
        <div
          id='visual'
          className='flex items-center justify-center flex-col bg-[url("/public/assets/images/product/bg_visual.jpg")] bg-cover bg-center h-[282px] md:h-[554px]'
        >
          <p
            className='text-center text-3xl md:text-[3.45rem] font-bold text-white md:leading-tight leading-5'
            data-aos='fade-up'
          >
            NOAH PRODUCTS
          </p>
          <p
            data-aos='fade-up'
            data-aos-duration='1000'
            className='mt-5 text-base font-medium text-center text-white md:mt-7 md:text-2xl'
          >
            건강하고 아름다운 미래의 꿈<br className='md:hidden' /> 노아와
            나아갑니다
          </p>
        </div>
        <div className='w-full max-w-[1920px] mx-auto flex flex-col lg:flex-row justify-center items-center py-14 lg:py-32'>
          <div className='px-5'>
            <img
              className='max-w-[210px] lg:max-w-[500px]'
              src={`${process.env.PUBLIC_URL}/assets/images/product/img_gb365_vertical.jpg`}
              alt=''
            />
          </div>
          <div className='px-5 text-center lg:text-left'>
            <p
              className='text-xl font-bold text-center lg:text-3xl lg:text-left'
              data-aos='fade-up'
              data-aos-duration='1000'
            >
              100% 천연 엔조제놀 액기스
            </p>
            <p className='text-4xl lg:text-[3.75rem] font-bold text-[#274274] mt-3 lg:mt-5 text-center lg:text-left'>
              GB365
            </p>
            <p className='mt-8 text-base font-medium leading-6 text-center lg:text-xl lg:text-left'>
              강력한 100% 천연 항산화. 항염증 물질로,
              <span className='block md:inline'>
                뉴질랜드산
                <br className='hidden md:block' /> 파이너스 라디아타
                소나무껍질을
              </span>{' '}
              <span className='block md:inline'>
                "국제특허 기술인
                <br className='hidden md:block' /> 순수 물 추출 공법"으로
              </span>{' '}
              추출한 100% 천연 건강 기능 식품
            </p>
            <a
              href='/detail'
              className='inline-block mt-6 md:mt-10 bg-[#103D81] rounded-full text-white font-medium text-sm py-[.94rem] px-6'
            >
              view more
            </a>
          </div>
        </div>
        <div className='mt-20'>
          <p className='text-2xl lg:text-[3.15rem] font-bold text-center text-[#103D80] leading-9 lg:leading-[1.3]'>
            혈중 중성지질개선,
            <br className='lg:hidden' /> 혈행 개선에 도움을 주는
            <br />
            GB365 체크 포인트!
          </p>
          <div className='relative lg:my-20 py-[3vw] lg:py-[4.5rem] my-8 lg:h-[822px] bg-cover bg-center text-center bg-[url("/public/assets/images/product/bg_product.png")]'>
            <div className='relative inline-block px-10'>
              <img
                className='inline-block'
                src={`${process.env.PUBLIC_URL}/assets/images/product/img_gb365_obj.png`}
                alt=''
              />
            </div>
          </div>
        </div>
        <div
          className='pb-20 lg:pb-40 lg:text-center'
          data-aos='fade-up'
          data-aos-duration='1000'
        >
          <ul className='lg:inline-block'>
            {productList.map((item, idx) => (
              <li
                className={`text-center lg:flex justify-center lg:text-left items-center lg:justify-normal lg:items-start ${
                  idx > 0 && 'mt-10 lg:mt-[4.4rem]'
                }`}
              >
                <img
                  className='inline-block'
                  src={`${process.env.PUBLIC_URL}/assets/images/product/ico_circle_check.svg`}
                  alt=''
                />
                <div className='mt-5 lg:mt-0 lg:text-left lg:ml-[3.2rem]'>
                  <p
                    className='font-bold text-2xl text-[#274274] lg:text-3xl lg:leading-[1.1]'
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  ></p>
                  <p
                    className='mt-4 text-base font-semibold lg:text-[1.4rem] lg:leading-9 lg:mt-5'
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  ></p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <Recommend />
        <Slogun />
        <Footer />
      </div>
    </>
  );
}

export default Product;
